/**
 * PageAsideElement — F12.H T12.H.2.
 *
 * Panel dodatkowy (aside) — boczna kolumna z dodatkowymi info (historia,
 * załączniki, komentarze) obok głównej treści formularza. Container.
 *
 * Settings: { position?: 'right'|'left', width?: 'narrow'|'wide', title? }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

export const PageAsideElement: LayoutElementDefinition = {
  type: 'page-aside',
  category: 'struktura',
  isContainer: true,
  label: 'Panel dodatkowy',
  icon: 'PanelRight',
  defaultSettings: () => ({
    position: 'right',
    width: 'narrow',
    title: '',
  }),
  render: ({ element, children, mode }) => {
    const settings = (element.settings ?? {}) as {
      position?: 'right' | 'left';
      width?: 'narrow' | 'wide';
      title?: string;
    };
    const widthClass = settings.width === 'wide' ? 'w-96' : 'w-72';
    const isBuilder = mode === 'builder';

    return (
      <aside
        className={`${widthClass} shrink-0 rounded-lg border border-border-primary bg-bg-secondary/50 p-3 ${isBuilder ? 'ring-2 ring-transparent hover:ring-accent-200 transition' : ''}`}
        data-testid={`page-aside-element-${element.id}`}
        data-element-type="page-aside"
        data-position={settings.position ?? 'right'}
      >
        {settings.title && (
          <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-text-secondary">
            {settings.title}
          </h3>
        )}
        {children.length > 0 ? (
          <div className="space-y-2">{children}</div>
        ) : isBuilder ? (
          <p className="text-xs italic text-text-muted">(panel pusty — przeciągnij elementy)</p>
        ) : null}
      </aside>
    );
  },
};
